/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Open_In_New_TabInputs */

const en_orders_open_in_new_tab = /** @type {(inputs: Orders_Open_In_New_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open In New Tab`)
};

const es_orders_open_in_new_tab = /** @type {(inputs: Orders_Open_In_New_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir en nueva pestana`)
};

/**
* | output |
* | --- |
* | "Open In New Tab" |
*
* @param {Orders_Open_In_New_TabInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_open_in_new_tab = /** @type {((inputs?: Orders_Open_In_New_TabInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Open_In_New_TabInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_open_in_new_tab(inputs)
	return es_orders_open_in_new_tab(inputs)
});